import { gql } from '@apollo/client/core';

export const WINDOW_PACING_METRICS = gql`
  fragment windowPacingMetrics on WindowPacingMetrics {
    id
    pacing
    totalImpressions
  }
`;
